import { AuditEntity } from './AuditEntity';
import { DepartmentTemplate } from './DepartmentTemplate';
import { Language } from './Language';

export interface Store extends AuditEntity {
  name: string;
  departments: Department[];
  defaultLanguage: Language;
  externalId: string;
}

export enum StoreField {
  ID = 'id',
  EXTERNAL_ID = 'externalId',
  NAME = 'name',
  DEPARTMENTS = 'departments',
  DEFAULT_LANGUAGE = 'defaultLanguage',
}

export interface Department extends AuditEntity {
  departmentTemplate: DepartmentTemplate;
}
